import type { SVGProps } from 'react';

export function IconSparkles(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            {...props}
        >
            <path d="M12 3l1.9 5.8L20 10l-5.8 2.1L12 18l-2.1-5.9L4 10l6.1-1.2z" />
            <path d="M19 3v4" />
            <path d="M21 5h-4" />
        </svg>
    );
}
